import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { TYPEMODULE, LoaderService, NotificationService, GridDataSource } from '../../../../shared/session/index';
import { AccessService } from '../../Accesses/shared/access.service';
import { PageEvent } from '@angular/material';

@Component({
  selector: 'app-rol-access-list',
  templateUrl: 'rol-access-list.component.html',
})

export class RolAccessListComponent implements OnInit {
  @Output() onChangeEvent: EventEmitter<any> = new EventEmitter();
  @Input() typeModule: TYPEMODULE;
  @Input() titlePage: string;
  @Input() data: any;

  displayedColumns: string[];
  dataSource: GridDataSource;
  msgErrorGet: string;
  selectedRowIndex: number = -1;
  pageSize: number;
  pageEvent: PageEvent;

  constructor(
    private loaderService: LoaderService,
    private accessService: AccessService,
    private notificationService: NotificationService
  ) { }

  ngOnInit() {
    this.pageSize = 0;
    this.pageEvent = new PageEvent();
    this.msgErrorGet = 'Error al listar los Accesos';
    this.displayedColumns = ['AccessID', 'entidadName', 'AplicacionName', 'RoleName', 'Name', 'Path', 'Icono', 'Description', 'Status'];
  }

  searchEmit(data: any) {
    this.buscarAccess(this.data.rol.ID, data.filtro);
  }

  changeEvent(event) {
    this.onChangeEvent.emit(event);
  }

  buscarAccess(RoleID: number, filtro: string) {
    this.listAplicacionesOffice(RoleID, filtro);
  }

  listAplicacionesOffice(RoleID: number, filtro: string) {
    this.loaderService.show();
    this.accessService.listarPorRole(RoleID, filtro)
      .subscribe(res => {
        this.dataSource = new GridDataSource(res);
      },
        error => {
          this.notificationService.error(this.msgErrorGet);
          throw error;
        },
        () => {
          this.loaderService.hide();
        });
  }
}

